import React from "react";
import { DishList } from "@/components/organisms/DishList";

export const Menu = () => {
  const handleProductSelect = (product) => {
    console.log("Product selected:", product);
    // TODO: Implement product selection logic
  };

  const handleCategorySelect = (category) => {
    console.log("Category selected:", category);
    // TODO: Implement category filtering logic
  };

  const handleRefresh = () => {
    console.log("Refreshing menu data...");
    // Additional refresh logic can be added here if needed
  };

  return (
    <DishList
      onProductSelect={handleProductSelect}
      onCategorySelect={handleCategorySelect}
      onRefresh={handleRefresh}
      showCategoryNavigation={true}
    />
  );
};
